var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.25 31.6592C58.25 17.073 46.4987 5.25 32 5.25C17.5013 5.25 5.75 17.073 5.75 31.6592C5.75 44.8437 15.347 55.769 27.898 57.75V39.2945H21.234V31.6575H27.898V25.8405C27.898 19.222 31.8163 15.5645 37.8135 15.5645C40.6835 15.5645 43.69 16.0808 43.69 16.0808V22.5802H40.3773C37.117 22.5802 36.102 24.6172 36.102 26.7067V31.6592H43.382L42.2183 39.2927H36.102V57.75C48.653 55.769 58.25 44.8437 58.25 31.6592Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bd6e7572191842611ec238e0f8b79207.svg";
export { ForwardRef as ReactComponent };